// UI language: Finnish by default, per user (PATCH /api/me), mirrored in localStorage.
import type { UiLang } from '@valyrio/engine/types';
import { useApp } from '../state/store';
import { en } from './en';
import { fi, type Messages } from './fi';

export type { Messages };
export const messages: Record<UiLang, Messages> = { fi, en };

export function useT(): Messages {
  return messages[useApp((s) => s.lang)];
}

export function useLang(): UiLang {
  return useApp((s) => s.lang);
}
